import Vue from 'vue'
import VueRouter from 'vue-router'

import Login from '../views/Login.vue'

import Parking from '../views/parking/Index.vue'
import Parking_one from '../views/parking/One.vue'
import Parking_one_common from '../views/parking/One_common.vue'
import Parking_one_slot from '../views/parking/One_slot.vue'
import Parking_one_price from '../views/parking/One_price.vue'
import Parking_one_discount from '../views/parking/One_discount.vue'
import Parking_one_configuration from '../views/parking/One_configuration.vue'
import Parking_one_information from '../views/parking/One_information.vue'
import Parking_one_timetable from '../views/parking/One_timetable.vue'
import Parking_one_assistant from '../views/parking/One_assistant.vue'
import Parking_one_booking from '../views/parking/One_booking.vue'
import Parking_one_occupation from '../views/parking/One_occupation.vue'
import Parking_one_transaction from '../views/parking/One_transaction.vue'
import Parking_one_qr from '../views/parking/One_qr.vue'

import Parking_transaction from '../views/parking_transaction/Index.vue'
import Transactions_user from '../views/transactions_user/Index.vue'

import Parking_add from '../views/parking/Add.vue'

import Users from '../views/users/Index.vue'
import Users_one from '../views/users/One.vue'
import Users_one_common from '../views/users/One_common.vue'
import Users_one_user_transactions from '../views/users/One_user_transactions.vue'
import Users_one_owner_transactions from '../views/users/One_owner_transactions.vue'

import Mailout from '../views/users/Mailout.vue'

import Booking_request from '../views/booking_request/Index.vue'
import Booking_request_one from '../views/booking_request/One.vue'
import Booking_request_one_contacts from '../views/booking_request/One_contacts.vue'
import Booking_request_one_info from '../views/booking_request/One_info.vue'
import Booking_request_one_shedule from '../views/booking_request/One_shedule.vue'
import Booking_request_one_price from '../views/booking_request/One_price.vue'

import Booking from '../views/booking/Index.vue'
import Booking_one from '../views/booking/One.vue'

import Authorization from '../views/authorization/Index.vue'
import Authorization_one from '../views/authorization/One.vue'

import Feedback from '../views/feedback/Index.vue'
import Feedback_one from '../views/feedback/One.vue'

import Coupon from '../views/coupon/Index.vue'
import Coupon_one from '../views/coupon/One.vue'

import Coupon_type from '../views/coupon_type/Index.vue'
import Coupon_type_one from '../views/coupon_type/One.vue'

import Owner from '../views/owner/Index.vue'

import Cases from '../views/email_case/Index.vue'
import Cases_one from '../views/email_case/One.vue'

import store from './../store'

Vue.use(VueRouter)

  const routes = [
  {
      path: '/',
      redirect: '/parking'
  },
  {
      path: '/login',
      name: 'login',
      component: Login
  },
  {
      path: '/parking/:id',
      redirect: '/parking/:id/common'
  },
  {
      path: '/users/:id',
      redirect: '/users/:id/common'
  },
  {
    path: '/parking',
    name: 'parking',
    meta: {
        requiresAuth: true
    },
    component: Parking,
    children: [
        {
            name: 'parking_one',
            path: ':id',
            component: Parking_one,
            children: [
                {
                    name: 'parking_one_common',
                    path: 'common',
                    component: Parking_one_common,
                },
                {
                    name: 'parking_one_slot',
                    path: 'slot',
                    component: Parking_one_slot,
                },
                {
                    name: 'parking_one_price',
                    path: 'price',
                    component: Parking_one_price,
                },
                {
                    name: 'parking_one_discount',
                    path: 'discount',
                    component: Parking_one_discount,
                },
                {
                    name: 'parking_one_configuration',
                    path: 'configuration',
                    component: Parking_one_configuration,
                },
                {
                    name: 'parking_one_information',
                    path: 'information',
                    component: Parking_one_information,
                },
                {
                    name: 'parking_one_timetable',
                    path: 'timetable',
                    component: Parking_one_timetable,
                },
                {
                    name: 'parking_one_assistant',
                    path: 'assistant',
                    component: Parking_one_assistant,
                },
                {
                    name: 'parking_one_booking',
                    path: 'booking',
                    component: Parking_one_booking,
                },
                {
                    name: 'parking_one_occupation',
                    path: 'occupation',
                    component: Parking_one_occupation,
                },
                {
                    name: 'parking_one_transaction',
                    path: 'transaction',
                    component: Parking_one_transaction,
                },
                {
                    name: 'parking_one_qr',
                    path: 'qr',
                    component: Parking_one_qr,
                },
            ]
        }
    ]
  },
  {
      path: '/parking_add',
      name: 'parking_add',
      meta: {
          requiresAuth: true
      },
      component: Parking_add
  },
  {
      path: '/parking_transaction',
      name: 'parking_transaction',
      meta: {
          requiresAuth: true
      },
      component: Parking_transaction
  },
  {
      path: '/transactions_user',
      name: 'transactions_user',
      meta: {
          requiresAuth: true
      },
      component: Transactions_user
  },
  {
    path: '/users',
    name: 'users',
    meta: {
        requiresAuth: true
    },
    component: Users,
    children: [{
        name: 'users_one',
        path: ':id',
        component: Users_one,
        children: [
            {
                name: 'users_one_common',
                path: 'common',
                component: Users_one_common,
            },
            {
                name: 'users_one_user_transactions',
                path: 'user_transactions',
                component: Users_one_user_transactions,
            },
            {
                name: 'users_one_owner_transactions',
                path: 'owner_transactions',
                component: Users_one_owner_transactions,
            }
        ]
    }]
  },
  {
      path: '/mailout',
      name: 'mailout',
      meta: {
          requiresAuth: true
      },
      component: Mailout
  },
  {
      path: '/booking_request/:id',
      redirect: '/booking_request/:id/contacts'
  },
  {
    path: '/booking_request',
    name: 'booking_request',
    meta: {
        requiresAuth: true
    },
    component: Booking_request,
    children: [
        {
            name: 'booking_request_one',
            path: ':id',
            component: Booking_request_one,
            children: [
                {
                    name: 'booking_request_one_contacts',
                    path: 'contacts',
                    component: Booking_request_one_contacts,
                },
                {
                    name: 'booking_request_one_info',
                    path: 'info',
                    component: Booking_request_one_info,
                },
                {
                    name: 'booking_request_one_shedule',
                    path: 'shedule',
                    component: Booking_request_one_shedule,
                },
                {
                    name: 'booking_request_one_price',
                    path: 'price',
                    component: Booking_request_one_price,
                }
            ]
        }
    ]
  },
  {
      path: '/booking',
      name: 'booking',
      meta: {
          requiresAuth: true
      },
      component: Booking,
      children: [{
          name: 'booking_one',
          path: ':id',
          component: Booking_one,
      }]
  },
  {
    path: '/authorization',
    name: 'authorization',
    meta: {
        requiresAuth: true
    },
    component: Authorization,
    children: [
        {
            name: 'authorization_one',
            path: ':id',
            component: Authorization_one
        }
    ]
  },
  {
      path: '/feedback',
      name: 'feedback',
      meta: {
          requiresAuth: true
      },
      component: Feedback,
      children: [
          {
              name: 'feedback_one',
              path: ':id',
              component: Feedback_one
          }
      ]
  },
  {
      path: '/coupon',
      name: 'coupon',
      meta: {
          requiresAuth: true
      },
      component: Coupon,
      children: [
          {
              name: 'coupon_one',
              path: ':id',
              component: Coupon_one
          }
      ]
  },
  {
      path: '/coupon_type',
      name: 'coupon_type',
      meta: {
          requiresAuth: true
      },
      component: Coupon_type,
      children: [
          {
              name: 'coupon_type_one',
              path: ':id',
              component: Coupon_type_one
          }
      ]
  },
  {
      path: '/owner',
      name: 'owner',
      meta: {
          requiresAuth: true
      },
      component: Owner,
  },
  {
      path: '/email_case',
      name: 'email_case',
      meta: {
          requiresAuth: true
      },
      component: Cases,
      children: [
          {
              name: 'email_case_one',
              path: ':id',
              component: Cases_one
          }
      ]
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {

    if (from.name == 'parking' || from.name == 'parking_transaction' || from.name == 'transactions_user' || from.name == 'users' ||
        from.name == 'booking' || from.name == 'booking_request' || from.name == 'authorization' || from.name == 'feedback' ||
        from.name == 'coupon' || from.name == 'coupon_type' || from.name == 'owner' || from.name == 'email_case') {
        let config = {
            settings: store.state.settings[from.name],
            filters: store.state.filters[from.name]
        }
        let key = 'config_' + from.name
        localStorage[key] = JSON.stringify(config)
    }

    if(to.matched.some(record => record.meta.requiresAuth)) {
        if (store.getters['auth/isLoggedIn']) {
            next()
            return
        }
        next('/login')
    } else {
        next()
    }
})

export default router
